export function alerts(state) {
	return state.alerts;
}

export function is_alert(state) {
	return state.alerts.length > 0;
}
